import Thumbnail1 from "./images/blog90.jpg";
import Thumbnail2 from "./images/blog15.jpg";
import Thumbnail3 from "./images/blog2.jpg";
import Thumbnail4 from "./images/blog51.jpg";

export const dummyPosts = [
    {
      id: "1",
      thumbnail: Thumbnail1,
      category: "education",
      title: "This is the title of the very first post on this blog",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus, earum unde perspiciatis blanditiis ut possimus?",
      authorID: 3,
    },
    {
      id: "2",
      thumbnail: Thumbnail2,
      category: "science",
      title: "This is the title of the very second post on this blog",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus, earum unde perspiciatis blanditiis ut possimus?",
      authorID: 1,
    },
    {
      id: "3",
      thumbnail: Thumbnail3,
      category: "weather",
      title: "This is the title of the very third post on this blog",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus, earum unde perspiciatis blanditiis ut possimus?",
      authorID: 13,
    },
    {
      id: "4",
      thumbnail: Thumbnail4,
      category: "farming",
      title: "This is the title of the very fourth post on this blog",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus, earum unde perspiciatis blanditiis ut possimus?",
      authorID: 3,
    },
  ];